import ForBidden from '@/pages/403'
import NotFound from '@/pages/404'
import Dashboard from '@/pages/Dashboard'
import Login from '@/pages/Login'
import Logout from '@/pages/Logout'
import VideoInstitucional from '@/pages/VideoInstitucional/Dashboard'
import Agenda from '@/pages/agenda/Dashboard'
import ClienteForm from '@/pages/cliente/Form'
import ClienteLista from '@/pages/cliente/Lista'
import Comissao from '@/pages/comissao/Lista'
import CatalogoVirtual from '@/pages/download/DetalheCatalogoVirtual'
import MaterialApoio from '@/pages/download/DetalheMaterialApoio'
import Treinamento from '@/pages/download/DetalheTreinamento'
import Meta from '@/pages/meta/Dashboard'
import OrcamentoCliente from '@/pages/orcamento/FormCliente'
import OrcamentoClienteEdit from '@/pages/orcamento/FormClienteEdit'
import OrcamentoInativo from '@/pages/orcamento/FormInativo'
import OrcamentoInativoEdit from '@/pages/orcamento/FormInativoEdit'
import OrcamentoProspect from '@/pages/orcamento/FormProspect'
import OrcamentoProspectEdit from '@/pages/orcamento/FormProspectEdit'
import OrcamentoLista from '@/pages/orcamento/Lista'
import PedidoForm from '@/pages/pedido/Form'
import PedidoLista from '@/pages/pedido/Lista'
import PedidoSupervisionado from '@/pages/pedido/piller/FormPedidoSupervisionadoPiller'
import Titulo from '@/pages/titulo/Lista'
import Vue from 'vue'
import Router from 'vue-router'

import LoginAdmin from '@/pages/LoginAdmin'
import DashboardAdmin from '@/pages/admin/Dashboard'
import ParametroPortal from '@/pages/admin/parametroPortal/Form'

Vue.use(Router)

export default new Router({
  routes: [
    // Páginas
    { path: '/404', component: NotFound },
    { path: '/403', component: ForBidden },
    { path: '/dashboard', component: Dashboard },
    { path: '/meta', component: Meta },
    { path: '/pedido/consulta', component: PedidoLista },
    { path: '/pedido/novo', component: PedidoForm },
    { path: '/pedido/supervisionado', component: PedidoSupervisionado },
    { path: '/cliente/consulta', component: ClienteLista },
    { path: '/cliente/novo', component: ClienteForm },
    { path: '/titulo', component: Titulo },
    { path: '/comissao', component: Comissao },
    { path: '/agenda', component: Agenda },
    { path: '/catalogo_virtual', component: CatalogoVirtual },
    { path: '/treinamento', component: Treinamento },
    { path: '/material_apoio', component: MaterialApoio },
    { path: '/video_institucional', component: VideoInstitucional },
    { path: '/orcamento/cliente', component: OrcamentoCliente },
    { path: '/orcamento/cliente/edit/:codigo', component: OrcamentoClienteEdit },
    { path: '/orcamento/prospect', component: OrcamentoProspect },
    { path: '/orcamento/consulta', component: OrcamentoLista },
    { path: '/orcamento/inativo', component: OrcamentoInativo },
    { path: '/orcamento/inativo/edit/:codigo', component: OrcamentoInativoEdit },
    { path: '/orcamento/prospect/edit/:codigo', component: OrcamentoProspectEdit },
    // Admin
    { path: '/admin/login', component: LoginAdmin },
    { path: '/admin/dashboard', component: DashboardAdmin },
    { path: '/admin/parametro_portal', component: ParametroPortal },

    // Redirecionamentos
    { path: '/sair', component: Logout },
    { path: '/login', component: Login },
    { path: '/', component: Login },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js